/**
 * Clases de chip del design system para el estado de una solicitud.
 * Mismo mapeo que usa la bandeja de autorizaciones.
 */
export function estadoChipClase(stateNumber: number): string {
    switch (stateNumber) {
        case 4:
            return 'ds-chip--aprobado';
        case 3:
            return 'ds-chip--auditoria';
        case 2:
            return 'ds-chip--revision';
        case 7:
            return 'ds-chip--recupero';
        case 6:
            return 'ds-chip--espera';
        case 5:
            return 'ds-chip--anulado';
        default:
            return 'ds-chip--neutro';
    }
}
